import {
  formatEventSchedule,
  getTimezoneDate,
  timezones,
} from '../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'
import Form from 'react-bootstrap/Form'

import { groupEventsBySeason } from './groupEventsBySeason'

export default function EventSelector({
  events,
  selected,
  setSelected,
  isLoading,
  groupByYear = false,
  groupBySeason = false,
  showYear = false,
  label = 'Event',
  emptyOptionText = 'Select Event',
}) {
  const getEventDate = (event) =>
    getTimezoneDate(
      event?.start,
      timezones(event?.venue?.timezone || event?.venue?.[0]?.timezone)
    )

  const getEventYear = (event) => {
    const eventDate = getEventDate(event)
    const eventYear = new Date(eventDate).getFullYear()
    return Number.isNaN(eventYear) ? null : eventYear
  }

  const currentYear = new Date().getFullYear()

  const groupedEvents = (events || []).reduce((acc, event) => {
    const year = getEventYear(event)
    const yearKey = year ?? 'Unknown'

    if (!acc[yearKey]) {
      acc[yearKey] = []
    }

    acc[yearKey].push(event)
    return acc
  }, {})

  const sortedYearGroups = Object.entries(groupedEvents).sort(([a], [b]) => {
    if (a === 'Unknown') return 1
    if (b === 'Unknown') return -1

    const yearA = Number(a)
    const yearB = Number(b)

    if (yearA === currentYear && yearB !== currentYear) return -1
    if (yearB === currentYear && yearA !== currentYear) return 1

    return yearB - yearA
  })

  const renderOption = (event, index) => (
    <option key={`${event.uuid}-${index}`} value={event.uuid}>
      {event.name} -{' '}
      {formatEventSchedule(
        event,
        timezones(event?.venue?.timezone || event?.venue?.[0]?.timezone),
        { includeYear: showYear }
      )}
    </option>
  )

  return (
    <Stack>
      <Form.Group controlId="select-event">
        <Form.Label>{label}</Form.Label>
        <div className="flex-grow-1">
          <Form.Select
            name="select-event"
            onChange={(e) => setSelected(e.target.value)}
            value={selected}
            disabled={isLoading}
          >
            <option value="">{emptyOptionText}</option>
            {events &&
              events?.length > 0 &&
              (groupBySeason
                ? groupEventsBySeason(events).map((group) => (
                    <optgroup key={group.key} label={group.label}>
                      {group.events.map((event, index) =>
                        renderOption(event, index)
                      )}
                    </optgroup>
                  ))
                : groupByYear
                  ? sortedYearGroups.map(([year, groupedYearEvents]) => (
                      <optgroup key={year} label={year}>
                        {groupedYearEvents.map((event, index) =>
                          renderOption(event, index)
                        )}
                      </optgroup>
                    ))
                  : events.map((event, index) => renderOption(event, index)))}
          </Form.Select>
        </div>
      </Form.Group>
    </Stack>
  )
}
